import React, { Component } from 'react';
import moment from 'moment';
import { Breadcrumb, MainHeading, Divider, DatePicker } from '../common/atoms';
import { Modal } from '../modals';
import { Table, Pagination } from '../common/molecules';
import { ACTIVITY_INITIAL_STATE, TOTAL_AHC, TOTAL_VACCINATIONS, TOTAL_GYMS, TOTAL_SPENDING_ACCOUNT } from '../../constants/utilization';
import { utilizationApi } from '../../services';
import {handleAppError, getLocalStorage} from '../handlers';
import { filter_plus_blue, filter_plus, download_btn, filterIcon, filter_img, greenTickThick, popup_close as closebtn, xmarkIcon } from '../../assets/images';
import Skeleton from 'react-loading-skeleton';
import { successOrFailureToaster } from '../common/atoms/messages';
import {Row, Col, Popover, Radio} from 'antd'
import ActivityLogFiltersModal from '../modals/ActivityLogFiltersModal';
import { SALES_ROLE } from '../../constants/overview';
import { dsButtonGhostBrand, dsButtonPrimary, joinButtonClasses } from '../../utils/buttonStyles';

class ActivityLog extends Component {
  constructor(props) {
    super(props);
    const query = new URLSearchParams(this.props.location.search).get('point');
    const benefitName = new URLSearchParams(this.props.location.search).get('benefit_name');
    this.state = {
      showModal: false,
      showFilterModal: false,
      filterApplicable: false,
      ...ACTIVITY_INITIAL_STATE(benefitName || query)[query],
      data: [],
      filterParams: {},
      filterDates: {startDate: null, endDate: null},
      packages: [],
      contractStartDate: null,
      contractEndDate: null,
      curPageData: [],
      totalpages: null,
      curpage: 0,
      covid_startDate: null,
      covid_endDate: null,
      vaccination_status: null,
      covid_history: null,
      datesChanged: false,
      loading: true,
      query: query,
      benefitName: benefitName
    };
  }

  benefitArr = ['ahc', 'nhc', 'dental', 'vision', 'covid_vaccination', 'flu_vaccination', 'specialist_consultation', 'occupational_medical_rooms', 'combined_vision_items',
                'cancer_screening', 'fertility_treatment', 'inclinic_consultation', 'pre_employment', 'physiotherapy']

  separateLogFilters = ['consultation', 'pharmacy']
  componentDidMount() {
    let customersOptions = {
      page: this.state.curpage+1,
      per_page:10
    }
    this.setState({startDate: moment(this.props.location.state.start_date).format('DD-MM-YYYY'), endDate: moment(this.props.location.state.end_date).format('DD-MM-YYYY'), contractStartDate: this.props.location.state.start_date, contractEndDate: this.props.location.state.end_date, filterDates: {
      startDate: this.props.location.state.start_date, endDate: this.props.location.state.end_date}})
    if(this.benefitArr.includes(this.state.query) || this.separateLogFilters.includes(this.state.query)){
      this.setState({filterApplicable: true})
    }
    const { start_date: startDate, end_date: endDate, contract_id: contractId } = this.props.location.state;
    let benefit_type = this.benefitArr.includes(this.state.query) ? this.state.query : ''
    let options = this.benefitArr.includes(this.state.query)
      ? {
          startDate,
          endDate,
          page: this.state.curpage + 1,
          contractId,
          benefit_type,
          filters: JSON.stringify(this.state.filterParams || {})
        }
      : {
          startDate,
          endDate,
          str: this.state.str,
          page: this.state.curpage + 1,
          contractId,
          benefit_type
        };
    const api = this.benefitArr.includes(this.state.query)
      ? utilizationApi.fetchCommonAhcDentalVisionActivityLogFilters
      : this.state.query === 'pharmacy'
        ? utilizationApi.fetchPharmacyActivityLogFilters
        : this.state.query === 'consultation'
          ? utilizationApi.fetchConsultationActivityLogFilters
          : utilizationApi.fetchActivityLog;
    api(options, this.onSuccess, (err) => {
      handleAppError(err);
    });
    if (this.benefitArr.includes(this.state.query)){
      const package_api = utilizationApi.fetchCommonAhcDentalVisionFetchPackages
      package_api({
        startDate,
        endDate,
        contractId,
        benefit_type
      },
      (resp)=>{
        const packages = resp.data.packages;
        this.setState({packages: packages})
      },
      (err) => {
        handleAppError(err);
      }
      );
    }
  }

  onErrorCustomerData = (err) => {
    handleAppError(err);
  }

  updateFilters = (page) => {
    const {covid_history, vaccination_status} = this.state
    const [valid, covid_startDate, covid_endDate] = this.validateDates();
    let vaccinated = [1,2].includes(vaccination_status) ? true : false
    let dose_number = vaccinated ? vaccination_status === 1 ? 1 : 2 : ''
    let covid_infected = covid_history === 4 
    let options = {
      page: page === undefined ? 1 : page + 1,
      per_page: 10
    }
    if(covid_startDate) options.start_date = covid_startDate
    if(covid_endDate) options.end_date = covid_endDate
    if(vaccination_status !== null) options.vaccinated = vaccinated
    if(vaccination_status !== null && vaccination_status !== 3) options.dose_number = dose_number
    if(covid_history!== null) options.covid_infected = covid_infected
    return options
  }

  updateActivityLogDataWithFilters = (page) =>{
    let contractId = this.props.location.state.contract_id;
    let {startDate, endDate} =this.state.filterDates;
    let filters = this.state.filterParams;
    let benefit_type = this.state.query
    let options = {
      headers: { 'Content-Type': 'application/json' },
      startDate,
      endDate,
      page: page + 1,
      contractId,
      benefit_type,
      filters: JSON.stringify(filters)
    }
    const filter_api = this.state.query === 'pharmacy' ? utilizationApi.fetchPharmacyActivityLogFilters : this.state.query === 'consultation' ? utilizationApi.fetchConsultationActivityLogFilters : utilizationApi.fetchCommonAhcDentalVisionActivityLogFilters
    filter_api(options,
      (resp)=>{
        let data = [];
        if(this.benefitArr.includes(this.state.query))
          data = resp.data.appointments
        const curPageData = data
        const totalpages = resp.data.meta ? Math.ceil(resp.data.meta.total/ 10) : Math.ceil(resp.data.total_count/10);
        this.setState({
          data,
          curPageData,
          curpage: this.state.curpage,
          totalpages,
          loading: false,
          totalCount: resp.data.meta ? resp.data.meta.total : resp.data.total_count
        });
      },
      (err) => {
        handleAppError(err);
      })
  }

  updateActivityLogData = (page) => {
    const { start_date: startDate, end_date: endDate, contract_id: contractId } = this.props.location.state;
    let benefit_type = this.benefitArr.includes(this.state.query) ? this.state.query : '';
    const useFiltersApi = this.benefitArr.includes(this.state.query) || this.separateLogFilters.includes(this.state.query);
    let options = useFiltersApi
      ? { startDate, endDate, page: page + 1, contractId, benefit_type, filters: JSON.stringify(this.state.filterParams || {}) }
      : { startDate, endDate, str: this.state.str, page: page + 1, contractId, benefit_type };
    const api = this.benefitArr.includes(this.state.query)
      ? utilizationApi.fetchCommonAhcDentalVisionActivityLogFilters
      : this.state.query === 'pharmacy'
        ? utilizationApi.fetchPharmacyActivityLogFilters
        : this.state.query === 'consultation'
          ? utilizationApi.fetchConsultationActivityLogFilters
          : utilizationApi.fetchActivityLog;
    api(options, this.onSuccess, (err) => {
      handleAppError(err);
    });
  }

  applyFilters = () => {
    this.setState({loading: true})
    this.updateActivityLogData()
  }

  paginateData = (page) => {
    if(this.benefitArr.includes(this.state.query) )
      this.updateActivityLogDataWithFilters(page)
    else 
      this.updateActivityLogData(page)
    this.setState({
      curpage: page,
      loading: true
    })
  };

  setTime = (type, date) => {
    this.setState({ [type]: date, datesChanged: true });
  };

  convertDateToUTC = (date) => {
    if(date){
    date = date.split('-');
    [date[0], date[2]] = [date[2], date[0]];
    return date.join('-');
    }
  };

  validateDates = () => {
    const startDate = this.convertDateToUTC(this.state.startDate);
    const endDate = this.convertDateToUTC(this.state.endDate);
    return [moment(startDate).isBefore(moment(endDate)), startDate, endDate];
  };
  
  getTotalRecords = (key) => {
    switch (key) {
      case 'ahc':
        return getLocalStorage(TOTAL_AHC)
      case 'vaccination':
        return getLocalStorage(TOTAL_VACCINATIONS)
      case 'fitness': 
        return getLocalStorage(TOTAL_GYMS)
      case 'spending_account':
        return getLocalStorage(TOTAL_SPENDING_ACCOUNT)  
      default:
        return 0;
    }
  }

  updateFilterData = (resp) =>{
    let data = [];
    if(this.benefitArr.includes(this.state.query) || this.separateLogFilters.includes(this.state.query))
      data = resp.data?.appointments || resp.data?.orders || resp.data?.consultations
    const curPageData = data
    const totalpages = resp.data.meta ? Math.ceil(resp.data.meta.total/ 10) : Math.ceil(resp.data.total_count/10);
    this.setState({
      data,
      curPageData,
      curpage: 0,
      totalpages,
      loading: false,
      totalCount: resp.data.meta ? resp.data.meta.total : resp.data.total_count
    });
  }

  onSuccess = (resp) => {
    var data = [];
    if (this.benefitArr.includes(this.state.query) || this.state.query === 'fitness' || this.state.query === 'spending_account'){
      data = resp.data?.appointments
    } else if (this.state.query === 'vaccination') {
      data = resp.data?.vaccinations
    } else if (this.state.query === 'pharmacy') {
      data = resp.data?.orders
    } else if (this.state.query === 'consultation') {
      data = resp.data?.consultations
    }
    const curPageData = data
    const totalpages = resp.data.meta ? Math.ceil(resp.data.meta.total/ 10) : Math.ceil(resp.data.total_count/10);
    this.setState({
      data,
      curPageData,
      curpage: this.state.curpage,
      totalpages,
      loading: false,
      totalCount: resp.data.meta ? resp.data.meta.total : resp.data.total_count
    }, ()=> {
    });
  };

  btnhandler = (event) => {
    const element = event.target.innerText;

    if (this.state.datesChanged || element === 'Download') {
      const [valid, startDate, endDate] = this.validateDates();
      let benefit_type = this.benefitArr.includes(this.state.query) ? this.state.query : ''
      if (valid) {
        const { contract_id: contractId } = this.props.location.state;
        if (element === 'Download') {
          const api = this.benefitArr.includes(this.state.query) ? utilizationApi.downloadCommonAhcDentalVisionActivityLog : this.state.query === 'pharmacy' ? utilizationApi.downloadPharmacyActivityLog : this.state.query === 'consultation' ? utilizationApi.downloadConsultationActivityLog : utilizationApi.downloadActivityLog
          this.state.data.length > 0
            ? api(
                { startDate, endDate, str: this.state.query === 'spending_account' ? this.state.str + '_' : this.state.str.split('/')[0] + '/', contractId, benefit_type },
                (resp) => {
                  this.setState({ showModal: true });
                },
                (err) => handleAppError(err)
              ) 
            : successOrFailureToaster({ message: 'No data available to download', type: 'fail' });
        } else {
          const api = this.benefitArr.includes(this.state.query)
            ? utilizationApi.fetchCommonAhcDentalVisionActivityLogFilters
            : this.state.query === 'pharmacy'
              ? utilizationApi.fetchPharmacyActivityLogFilters
              : this.state.query === 'consultation'
                ? utilizationApi.fetchConsultationActivityLogFilters
                : utilizationApi.fetchActivityLog;
          const requestOptions = this.benefitArr.includes(this.state.query)
            ? { startDate, endDate, contractId, page: 1, benefit_type, filters: JSON.stringify(this.state.filterParams || {}) }
            : { startDate, endDate, str: this.state.str, contractId, page: 1, benefit_type };
          this.setState({ loading: true, datesChanged: false, curpage: 0 });
          api(requestOptions, this.onSuccess, (err) => {
            handleAppError(err);
          });
        }
      } else {
        successOrFailureToaster({ message: 'Selected Dates are incorrect format', type: 'fail' })
      }
    }
  };

  downloadData = () =>{
    let contractId = this.props.location.state.contract_id;
    let {startDate, endDate} = this.state.filterDates;
    let filters = this.state.filterParams;
    let benefit_type = this.state.query
    const api = benefit_type === 'pharmacy' ? utilizationApi.downloadPharmacyActivityLog : this.state.query === 'consultation' ? utilizationApi.downloadConsultationActivityLog : utilizationApi.downloadCommonAhcDentalVisionActivityLog
    this.state.data.length > 0
      ? api(
          { startDate, endDate, str: this.state.str.split('/')[0] + '/', contractId, benefit_type, filters: JSON.stringify(filters) },
          (resp) => {
            this.setState({ showModal: true });
          },
          (err) => handleAppError(err)
        ) 
      : successOrFailureToaster({ message: 'No data available to download', type: 'fail' });
  }

  filterHandler = () => { 
    const value = this.state.showFilterModal
    this.setState({showFilterModal: !value})
  }

  onCancel = () => {
    this.setState({
      contractStartDate: this.props.location.state.start_date,
      contractEndDate: this.props.location.state.end_date,
      filterDates: { startDate: this.props.location.state.start_date, endDate: this.props.location.state.end_date },
      filterParams: {},
      showFilterModal: false,
      loading: true,
      curpage: 0
    });
    const { start_date: startDate, end_date: endDate, contract_id: contractId } = this.props.location.state;
    let benefit_type = this.state.query;
    let options = {
      startDate,
      endDate,
      page: 1,
      contractId,
      benefit_type,
      filters: JSON.stringify({})
    };
    const filter_api = benefit_type === 'pharmacy' ? utilizationApi.fetchPharmacyActivityLogFilters : this.state.query === 'consultation' ? utilizationApi.fetchConsultationActivityLogFilters : utilizationApi.fetchCommonAhcDentalVisionActivityLogFilters
    filter_api(options, this.updateFilterData, (err) => {
      handleAppError(err);
    });
  }

  applyFilter = () => {
    this.setState({showFilterModal: false, loading: true})
    let contractId = this.props.location.state.contract_id;
    let {startDate, endDate} = this.state.filterDates;
    let filters = this.state.filterParams;
    let benefit_type = this.state.query
    let options = {
      headers: { 'Content-Type': 'application/json' },
      startDate,
      endDate,
      page: 1,
      contractId,
      benefit_type,
      filters: JSON.stringify(filters)
    }

    const filter_api = benefit_type === 'pharmacy' ? utilizationApi.fetchPharmacyActivityLogFilters : this.state.query === 'consultation' ? utilizationApi.fetchConsultationActivityLogFilters : utilizationApi.fetchCommonAhcDentalVisionActivityLogFilters
    filter_api(options, this.updateFilterData, (err) => {
      handleAppError(err);
    })
  }

  setFilterParams = (filterValue, filterType) =>{
    switch(filterType){
      case 'genders':
        this.setState({filterParams: {...this.state.filterParams, genders: filterValue}});
        break;
      case 'package_ids':
        this.setState({filterParams: {...this.state.filterParams, package_ids: filterValue}});
        break;
      case 'package_for':
        this.setState({filterParams: {...this.state.filterParams, package_for: filterValue}});
        break;
      case 'age_from':
        this.setState({filterParams: {...this.state.filterParams, age: {...this.state.filterParams.age, from: filterValue}}});
        break;
      case 'age_to':
        this.setState({filterParams: {...this.state.filterParams, age: {...this.state.filterParams.age, to: filterValue}}});
        break;
      case 'status':
        this.setState({filterParams: {...this.state.filterParams, status: filterValue}});
        break;
      case 'package_types':
        this.setState({filterParams: {...this.state.filterParams, package_types: filterValue}});
        break;
      case 'clear':
        this.setState({filterParams: {}});
    }
  }

  clearFilters = (type) =>{
    this.setState(prevState => {
      const {filterParams} = prevState;
      const { [type]: remove, ...rest} = filterParams;
      return {filterParams: rest};
    })
  };

  changeDates = (e, date_type) =>{
    let date = moment(e).format('YYYY-MM-DD')
    if (e){
      if (date_type === 'startDate'){
        this.setState({filterDates: {...this.state.filterDates, startDate: date}})
      }
      else if(date_type === 'endDate') {
        this.setState({filterDates: {...this.state.filterDates, endDate: date}})
      }
      else if(date_type === 'reset'){
        this.setState({filterDates: {startDate: moment(this.state.contractStartDate).format('YYYY-MM-DD'), endDate: moment(this.state.contractEndDate).format('YYYY-MM-DD')}})
      }
    }
    else{
      if (date_type === 'startDate'){
        this.setState({filterDates: {...this.state.filterDates, startDate: moment(this.state.contractStartDate).format('YYYY-MM-DD')}})
      }
      else {
        this.setState({filterDates: {...this.state.filterDates, endDate: moment(this.state.contractEndDate).format('YYYY-MM-DD')}})
      }
    }
  };

  goBack = () => {
    this.props.history.goBack();
  };
  onChangeVaccinationStatus = e => {
    e.target.value < 4 ? this.setState({vaccination_status: e.target.value}) : this.setState({covid_history: e.target.value});
  };

  handleRadioClick = (e) => {
    e.target.value < 4 ? this.setState({vaccination_status: e.target.value == this.state.vaccination_status ? null : e.target.value}) : this.setState({covid_history:  e.target.value == this.state.covid_history ? null : e.target.value});
  }

  renderAllFiltersOption(count=0){
    return(<>
    <div className='flex justify-end w-full justify-items-end mb-6'>
              <div className='flex'>
              {this.state.filterApplicable &&<button
              type='submit'
              className={`rounded border items-center flex  h-9 mr-4 bg-white text-lg font-semibold pl-2 py-2`}
              style={{width: `${ count > 0 ? '6.5rem' :'6rem'}`}}
              disabled={this.state.loading}
              onClick={this.filterHandler}
            >
              <img src={count > 0 ? `${filter_plus_blue}`: `${filter_plus}`} className='mr-2' style={{ width: 18}} alt='filters' />
              <span className={`text-lg font-semibold mr-1 ${count > 0 ? 'text-blue-500' : 'text-gray-600'}`}>
              Filter
              </span>
              {count>0 && <div className='bg-blue-500 text-white font-heavy flex justify-center items-center w-4 h-4' style={{fontSize:'0.6rem', lineHeight:'0.6rem', borderRadius: '50%', paddingTop: '0.05rem'}}>{count}</div>}
            </button>}
            { this.state.showFilterModal &&
              <ActivityLogFiltersModal
                filterParams={this.state.filterParams}
                visible={this.state.showFilterModal}
                startDate={this.state.contractStartDate}
                endDate={this.state.contractEndDate}
                onCancel={this.onCancel}
                setFilterParams={this.setFilterParams}
                clearFilters={this.clearFilters}
                filterDates={this.state.filterDates}
                changeDates={this.changeDates}
                benefit_type={this.state.benefit_type || this.state.query}
                contract_id={this.state.contractId}
                packages={this.state.packages}
                count={count}
                applyFilter={this.applyFilter}
              />}
                <button
                onClick={this.downloadData}
                className={joinButtonClasses(dsButtonPrimary, 'h-9 w-40 px-2 whitespace-nowrap', SALES_ROLE === 'sales' && 'cursor-not-allowed')}
                disabled={SALES_ROLE === "sales"} >
                <img src={download_btn} className='mr-2' style={{ width: 14}} alt='calender' />
                Download data
                </button>
              </div>
            </div>
    </>
    )
  }

  renderDateFilterOption(){
    return(
      <>
      <div className= 'bg-white flex justify-between p-2 rounded-md mb-6'>
             <div className='flex items-center ml-3'>
              <span className='mr-8 flex items-center'>
                <span className=' text-base font-semibold text-gray-600 mr-3'>From Date</span>
                <DatePicker value={this.state.startDate} handler={this.setTime.bind(this, 'startDate')} />
              </span>
              <span className=' flex items-center'>
                <span className='text-base font-semibold text-gray-600 mr-3'>To Date</span>
                <DatePicker value={this.state.endDate} handler={this.setTime.bind(this, 'endDate')} />
              </span>
              <button
                onClick={this.btnhandler}
                className={joinButtonClasses(dsButtonGhostBrand, 'ml-8 h-10 px-4')}
              >
                Apply filter
              </button>
            </div>
            <button
              onClick={this.btnhandler}
              className={joinButtonClasses(dsButtonPrimary, 'h-9 w-28 px-4', SALES_ROLE === 'sales' && 'cursor-not-allowed')}
              disabled={SALES_ROLE === "sales"}
            >
              Download
            </button>
          </div>
      </>
    )
  }

  renderProfileData(){
    return(
      <div style={{minWidth: 500}}>
        <Row type='flex' justify='start' style={{marginBottom: 20}}>
          <Col span={10}>
          <Row><span className=' text-sm font-semibold text-gray-500 mr-3'>From date</span></Row>
          <Row> <div style={{zIndex:100}}><DatePicker value={this.state.covid_startDate} handler={this.setTime.bind(this, 'covid_startDate')} /></div></Row>
          </Col>
          <Col span={10}>
          <Row><span className=' text-sm font-semibold text-gray-500 mr-3'>To date</span></Row>
          <Row> <DatePicker value={this.state.covid_endDate} handler={this.setTime.bind(this, 'covid_endDate')} /></Row>
          </Col>
        </Row>
        <Row type='flex' justify='start' style={{marginBottom: 10}}>
          <Col span={8}><h4><span className=' text-sm font-semibold text-gray-600 mr-3'>Vaccination status</span></h4></Col>
        </Row>
        <Row type='flex' justify='start' style={{marginBottom: 20}}>
        <Radio.Group onChange={(e)=>this.onChangeVaccinationStatus(e)} onClick={(e) => this.handleRadioClick(e)} value={this.state.vaccination_status}>
        <div className="flex flex-col space-y-4" >
          <Radio value={1} onClick={(value)=> this.handleRadioClick(value)}><span className='text-base font-semibold text-gray-700'>Partially Vaccinated</span></Radio>
          <Radio value={2} onClick={(value)=> this.handleRadioClick(value)}><span className='text-base font-semibold text-gray-700'>Fully vaccinated</span></Radio>
          <Radio value={3} onClick={(value)=> this.handleRadioClick(value)}><span className='text-base font-semibold text-gray-700'>Not vaccinated</span></Radio>
          </div>
      </Radio.Group>
        </Row >
        <Row type='flex' justify='start' style={{marginBottom: 10}}>
          <Col span={8}><h4><span className=' text-sm font-semibold text-gray-600 mr-3'>Covid-19 history</span></h4></Col>
        </Row>
        <Row type='flex' justify='start' style={{marginBottom: 20}}>
        <Radio.Group  onChange={(e)=>this.onChangeVaccinationStatus(e)} value={this.state.covid_history}>
          <Radio value={4} onClick={(value)=> this.handleRadioClick(value)}><span className=' text-base font-semibold text-gray-700'>Affected</span></Radio>
          <Radio value={5} onClick={(value)=> this.handleRadioClick(value)}><span className=' text-base font-semibold text-gray-700'>Not affected</span></Radio>
      </Radio.Group>
        </Row>
        <Row>
        </Row>
        <div className='p-2 border w-full border-gray-200' style={{marginBottom: '-4%', marginLeft:'-3.5%', width: '107%', backgroundColor: ' #F9FAFB'}} onClick={()=> this.applyFilters()}>
            <div className='flex flex-row justify-end'>
        <button className='rounded py-2 px-4 border border-gray-200 border-transparent bg-white text-sm font-semibold text-blue-500 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-rose-500'>Apply Filter</button>
       </div>
       
      </div>
      </div>
    )
  }

  render() {
    const { loading } = this.state;
    let dateChanged = (this.state.contractStartDate !== this.state.filterDates.startDate) || (this.state.contractEndDate !== this.state.filterDates.endDate)
    let count = Object.values(this.state.filterParams).length;
    dateChanged ? count++ : ''
    return (
      <div className='p-8 bg-gray-100 min-h-screen'>
        <img src={closebtn} alt='close-btn' className='absolute right-8 cursor-pointer h-8 w-8' onClick={this.goBack} />
        <Breadcrumb
          list={[{ text: 'Utilization', link: '/utilization/ahc' }, this.state.breadcrumb]}
          classes='mb-2 mt-5'
        />
        <MainHeading mainHeading={this.state.heading} classes='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl' />
        {this.state.query === 'ahc' && (<div className='text-sm'>
          {`This log shows all appointments for ${this.state.benefitName || this.state.query}. Please don't refer this for financial or billing reconciliations`}
        </div>)}
        <Divider classes='w-full mt-4 mb-4'/>

        {loading ? (
          <div className='mb-6'>
            <Skeleton width='100%' height={50} />
          </div>
        ) : 
            (
              <>{this.state.filterApplicable ? this.renderAllFiltersOption(count) : this.renderDateFilterOption()}
              </>
            )}

        <Table
          loading={loading}
          loaderHeight={300}
          headers={this.state.headers}
          data={this.state.curPageData}
          tableClasses={''}
          classes='rounded-lg'
          tableschema={this.state.tableschema}
        />
        {!loading && (this.state.curPageData || []).length > 0 && <Pagination
          loading={loading}
          totalpages={this.state.totalpages}
          totalresults={this.state.totalCount}
          curpage={this.state.curpage}
          handler={this.paginateData}
        />}
        <Modal
          visible={this.state.showModal}
          icon={greenTickThick}
          heading='Request received'
          body={`Dear ${sessionStorage.getItem(
            'hr_name'
          )}, the requested data will be sent to you on your email id within an hour.`}
          handler={() => this.setState({ showModal: false })}
        />
      </div>
    );
  }
}

export default ActivityLog;
